import { useState } from "react"
import { Button, Modal, Form } from "react-bootstrap"
import LoadingSpinner from "../Loading/LoadingSpinner"

export default function AddUserModal({ show, onClose, onSubmit, role }) {
  const label = role === "employee" ? "Employee" : "Customer"

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    address: "",
    city: "",
    state: "CA",
    zipcode: "",
    password: "",
    confirmPassword: "",
  })
  const [isLoading, setIsLoading] = useState(false)

  function handleChange(e) {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  function resetForm() {
    setFormData({
      firstName: "", lastName: "", email: "", mobile: "",
      address: "", city: "", state: "CA", zipcode: "",
      password: "", confirmPassword: "",
    })
  }

  async function handleSubmit() {
    const { firstName, lastName, email, mobile, password, confirmPassword } = formData
    if (!email || !email.includes("@")) return alert("Please enter a valid email.")
    if (!password || password.length < 6) return alert("Password must be at least 6 characters.")
    if (password !== confirmPassword) return alert("Passwords do not match.")
    if (!firstName || !lastName) return alert("Please enter first and last name.")
    if (!mobile || mobile.length !== 10 || !/^\d+$/.test(mobile))
      return alert("Please enter a valid 10-digit phone number.")

    setIsLoading(true)
    try {
      await onSubmit(formData)
      resetForm()
    } catch (err) {
      // Error handled by parent
    } finally {
      setIsLoading(false)
    }
  }

  function handleClose() {
    resetForm()
    onClose()
  }

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header className="custom-modal-header" closeButton>
        <Modal.Title>Add {label}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading && <LoadingSpinner />}
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>Email</Form.Label>
            <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Temporary Password</Form.Label>
            <Form.Control type="password" name="password" value={formData.password} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>First Name</Form.Label>
            <Form.Control type="text" name="firstName" value={formData.firstName} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Last Name</Form.Label>
            <Form.Control type="text" name="lastName" value={formData.lastName} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Mobile</Form.Label>
            <Form.Control type="tel" name="mobile" value={formData.mobile} onChange={handleChange} placeholder="5551235000" />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Address</Form.Label>
            <Form.Control type="text" name="address" value={formData.address} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>City</Form.Label>
            <Form.Control type="text" name="city" value={formData.city} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>State</Form.Label>
            <Form.Control type="text" name="state" value={formData.state} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Zipcode</Form.Label>
            <Form.Control type="text" name="zipcode" value={formData.zipcode} onChange={handleChange} />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="lg" onClick={handleClose}>Cancel</Button>
        <Button variant="success" size="lg" onClick={handleSubmit} disabled={isLoading}>Create {label}</Button>
      </Modal.Footer>
    </Modal>
  )
}
